module.exports = __webpack_public_path__ + "h5/img/ctus_bg.202539a9.png";